import React from "react";
import addIcon from "@/images/icons/add-icon.svg";
import openOutlineIcon from "@/images/icons/open-outline.svg";
import arrowIcon from "@/images/icons/arrow-forward-outline.svg";
import pdfIcon from "@/images/icons/pdf-icon.png";
import { AmiraResources } from "@/models/AmiraResources.interface";
import slidesIcon from "@/images/icons/google-slides-icon.svg";
import documentIcon from "@/images/icons/document-icon.svg";
interface ResourceBodyProps {
  handleOpenDetails: () => void;
  resources: AmiraResources[];
}

export const ResourceBody = ({
  handleOpenDetails,
  resources,
}: ResourceBodyProps) => {
  return (
    <div className="resource-modal-body">      
      <div className="resource-list d-flex flex-column overflow-y-auto">
        {resources.map((resource, index) => (
          <a key={index} className="bg-white hqim-card-mini-pdf d-flex align-items-center" 
          style={{border:'1px solid #F2E6F5'}}
            href={resource.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Open ${resource.title} in new tab`}
            title={`${resource.title}`}
          >
            {resource?.url?.toLowerCase().endsWith('pptx') ? (
              <img src={slidesIcon} alt="PowerPoint icon" className="pdf-icon-image" />
            ) : resource?.url?.toLowerCase().endsWith('pdf') ?(
              <img src={pdfIcon} alt="PDF icon" className="pdf-icon-image" />)
              : 
              (<img src={documentIcon} alt="Document icon" className="pdf-icon-image" />)
            }

            <span className="control-button pdf-title-text flex-grow-1">{resource.title}</span>
            <img className="open-outline" src={openOutlineIcon} alt="Open outline icon" />
          </a>
        ))}
      </div>
    </div>
  );
};
